<!-- Page Header -->
<div class="mb-4">
  <h1 class="h2 mb-1 fw-bold">ADN Fix in the Field Videos</h1>
  <p class="text-muted mb-0">Watch step-by-step guides on drone maintenance, repairs, and field fixes</p>
</div>

<!-- Videos Grid -->
<div class="row g-4">
  @for (video of videos; track $index) {
    <div class="col-md-4">
      <div class="video-card" role="button" (click)="openVideo(video)">
        <div class="video-card-image">
          <div class="ratio ratio-16x9">
            <img
              [src]="'https://img.youtube.com/vi/' + video.videoId + '/mqdefault.jpg'"
              [alt]="video.title"
              class="object-fit-cover"
            />
            <div class="video-play-overlay d-flex align-items-center justify-content-center">
              <div class="video-play-btn d-flex align-items-center justify-content-center rounded-circle">
                <i class="bi bi-play-fill"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="video-card-label">
          <p class="mb-0 fw-semibold small text-white">{{ video.title }}</p>
        </div>
      </div>
    </div>
  }
</div>

<!-- Video Modal -->
@if (activeVideo) {
  <div class="video-modal-backdrop" (click)="closeVideo()">
    <div class="w-100 mw-900px" (click)="$event.stopPropagation()">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="mb-0 fw-bold text-white">{{ activeVideo.title }}</h6>
        <button class="btn btn-sm btn-outline-light border-0" (click)="closeVideo()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="ratio ratio-16x9">
        <iframe
          [src]="activeVideo.embedUrl"
          [title]="activeVideo.title"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          class="rounded"
        ></iframe>
      </div>
    </div>
  </div>
}
